import React from "react"
import styled from "styled-components"
import { StaticQuery, graphql, Link } from "gatsby"
import groupby from "lodash.groupby"
import { Settings } from "../../../styles/theme"
import { Grid } from "../../atoms/grid"

const MediaReleasesStyled = styled.div`
  position: relative;
  margin: 2rem 0;
  a {
    text-decoration: none;
    color: ${Settings.greyColor};
  }
  > .constraint > div {
    align-items: flex-start;
  }
  .years-navigation {
    flex: 1 1 5%;
    @media screen and (max-width: ${Settings.sizeM}) {
      display: none;
    }
  }
  .years-navigation-mobile {
    display: none;
    @media screen and (max-width: ${Settings.sizeM}) {
      display: block;
    }
    border-bottom: 2px solid ${Settings.secondaryColor};
    position: relative;
    h6 {
      font-size: 2rem;
      font-weight: 700;
      color: ${Settings.secondaryColor};
    }
    .head {
      h6,
      b {
        display: inline-block;
        margin: 0;
      }
    }
    b {
      font-size: 2rem;
      color: ${Settings.secondaryColor};
      float: right;
    }
    .mobile-wrap {
      display: none;
      position: absolute;
      top: 3rem;
      left: 0;
      background: #fff;
      width: 100%;
      box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.5);
      z-index: 100;
      h6 {
        margin: 2rem;
      }
    }
    .mobile-wrap.active {
      display: block;
    }
  }
  .years-content {
    border-left: 3px solid ${Settings.secondaryColor};
    @media screen and (max-width: ${Settings.sizeM}) {
      border: none;
    }
    flex: 1 1 80%;
    .content {
      border-bottom: 1px solid rgba(0, 0, 0, 0.4);
      h6 {
        margin: 0;
        color: ${Settings.primaryColor};
        font-weight: 700;
      }
      .date {
        font-size: 0.9rem;
        opacity: 1;
      }
    }
  }
  .selected {
    position: relative;
    font-weight: 700;
    color: ${Settings.secondaryColor};
    &:after {
      content: " ";
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: -1.5rem;
      width: 0;
      height: 0;
      border-top: 5px solid transparent;
      border-bottom: 5px solid transparent;
      border-left: 10px solid ${Settings.secondaryColor};
    }
  }
`

class MediaReleases extends React.Component {
  constructor(props) {
    super(props)
    const releases = this.props.releases.allContentfulMediaReleases.edges
    const releaseYears = groupby(releases, rel => rel.node.publishedYear)
    const years = Object.keys(releaseYears).reverse()
    const defaultYear = years[0]
    this.state = {
      mediaReleases: releaseYears,
      selected: defaultYear,
      dropdown: false,
    }
  }

  handleSelected = i =>
    this.setState({
      selected: i,
    })

  handleDropdown = bool =>
    this.setState({
      dropdown: bool,
    })

  render() {
    return (
      <MediaReleasesStyled>
        <div className="constraint">
          <div className="years-navigation-mobile constraint">
            <div
              onClick={() => this.handleDropdown(!this.state.dropdown)}
              className="head"
            >
              <h6>{this.state.selected}</h6>
              <b>⌄</b>
            </div>
            <div
              className={
                this.state.dropdown ? "mobile-wrap active" : "mobile-wrap"
              }
            >
              {Object.keys(this.state.mediaReleases)
                .reverse()
                .map((year, i) => (
                  <a key={i}>
                    <h6
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.handleSelected(year)
                        this.handleDropdown(!this.state.dropdown)
                      }}
                    >
                      {year}
                    </h6>
                  </a>
                ))}
            </div>
          </div>
          <Grid>
            <div className="years-navigation">
              {Object.keys(this.state.mediaReleases)
                .reverse()
                .map((year, i) => (
                  <a key={i}>
                    <h6
                      style={{ cursor: "pointer" }}
                      className={this.state.selected === year ? "selected" : ""}
                      onClick={() => this.handleSelected(year)}
                    >
                      {year}
                    </h6>
                  </a>
                ))}
            </div>
            <div className="years-content">
              <div className="constraint">
                {this.state.mediaReleases[this.state.selected].map(
                  (release, i) => (
                    <div className="content" key={i}>
                      <p className="date">{release.node.publishedDate}</p>
                      <Link
                        to={
                          "/media-releases/" +
                          release.node.title
                            .replace(/\s+/g, "-")
                            .replace(/[!@#$%^&*?]/g, "")
                            .toLowerCase()
                        }
                      >
                        <h6>{release.node.title}</h6>
                      </Link>
                      <p>
                        {release.node.description
                          ? release.node.description.description
                          : ""}
                      </p>
                    </div>
                  )
                )}
              </div>
            </div>
          </Grid>
        </div>
      </MediaReleasesStyled>
    )
  }
}

export const MediaReleasesList = () => (
  <StaticQuery
    query={graphql`
      query MediaReleasesQuery {
        allContentfulMediaReleases {
          edges {
            node {
              id
              description {
                description
              }
              title
              publishedYear: publishedDate(formatString: "YYYY")
              publishedDate(formatString: "DD MMMM YYYY")
            }
          }
        }
      }
    `}
    render={data => <MediaReleases releases={data} />}
  />
)
